"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTransformFactory = void 0;
const rc_js_util_1 = require("rc-js-util");
const initialize_graphics_component_1 = require("../rendering/graphics-components/initialize-graphics-component");
/**
 * @public
 */
class ChartTransformFactory {
    constructor(renderer, transformsToInitialize, missIsDebugError) {
        this.renderer = renderer;
        this.transformsToInitialize = transformsToInitialize;
        this.missIsDebugError = missIsDebugError;
        this.transformMap = new Map();
    }
    addTransforms(transformFactories) {
        for (let i = 0, iEnd = transformFactories.length; i < iEnd; ++i) {
            this.addTransform(transformFactories[i]);
        }
        return this;
    }
    addTransform(transformFactory) {
        const byBinderSymbol = rc_js_util_1._Map.initializeGet(this.transformMap, transformFactory.userTransformId, () => new Map());
        byBinderSymbol.set(transformFactory.binderId, transformFactory);
        return this;
    }
    initializeTransformComponent(graphicsComponent) {
        var _a, _b;
        const transformBinder = graphicsComponent.transform.getTransformBinder();
        if (transformBinder == null) {
            // nothing to do, not a transformable component
            return;
        }
        const userTransforms = this.transformsToInitialize;
        const transformMap = this.transformMap;
        for (let i = 0, iEnd = userTransforms.length; i < iEnd; ++i) {
            const userTransform = userTransforms[i];
            const byBinderSymbol = transformMap.get(userTransform);
            if (byBinderSymbol == null) {
                DEBUG_MODE && rc_js_util_1._Debug.assert(!((_a = this.missIsDebugError) !== null && _a !== void 0 ? _a : false), "failed to find transform");
                continue;
            }
            const transformFactory = byBinderSymbol.get(transformBinder.binderClassificationId);
            if (transformFactory == null) {
                DEBUG_MODE && rc_js_util_1._Debug.assert(!((_b = this.missIsDebugError) !== null && _b !== void 0 ? _b : false), "failed to find transform");
                continue;
            }
            let transformComponent = transformFactory.createOne(transformBinder);
            const equivTransformComp = this.renderer.graphicsComponents.getComponent(transformComponent.getCacheId());
            if (equivTransformComp == null) {
                // first time we've seen this component
                (0, initialize_graphics_component_1.initializeGraphicsComponent)(this.renderer, transformComponent);
            }
            else {
                transformComponent = equivTransformComp;
            }
            this.renderer.transformComponents.setTransform(userTransform, graphicsComponent, transformComponent);
        }
    }
}
exports.ChartTransformFactory = ChartTransformFactory;
//# sourceMappingURL=chart-transform-factory.js.map